'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _AddIcon = require('../AddIcon');

var _AddIcon2 = _interopRequireDefault(_AddIcon);

var _getAddFavoritesHref = require('../helpers/getAddFavoritesHref');

var _getAddFavoritesHref2 = _interopRequireDefault(_getAddFavoritesHref);

var _trackSegmentEvent = require('../helpers/trackSegmentEvent');

var _trackSegmentEvent2 = _interopRequireDefault(_trackSegmentEvent);

var _windowPropType = require('../PropTypes/windowPropType');

var _windowPropType2 = _interopRequireDefault(_windowPropType);

var _userPropType = require('../PropTypes/userPropType');

var _userPropType2 = _interopRequireDefault(_userPropType);

var _entitlementsPropType = require('../PropTypes/entitlementsPropType');

var _entitlementsPropType2 = _interopRequireDefault(_entitlementsPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var trackAddFavorites = function trackAddFavorites(user, entitlements) {
  var loginStatus = user ? 'loggedIn' : 'loggedOut';
  var userType = 'anonymous';
  if (user) userType = entitlements.indexOf('sl_premium') > -1 ? 'sl_premium' : 'sl_basic';
  (0, _trackSegmentEvent2.default)('Clicked Add Favorites', {
    ctaLocation: 'Favorites Bar',
    loginStatus: loginStatus,
    userType: userType
  });
};

var addFavoritesClasses = function addFavoritesClasses(large) {
  var classes = {};
  classes['quiver-add-favorites'] = true;
  classes['quiver-add-favorites--large'] = large;
  return (0, _classnames2.default)(classes);
};

var AddFavorites = function AddFavorites(_ref) {
  var large = _ref.large,
      user = _ref.user,
      entitlements = _ref.entitlements,
      window = _ref.window;
  return _react2.default.createElement(
    'a',
    {
      className: addFavoritesClasses(large),
      href: (0, _getAddFavoritesHref2.default)(window ? window.location.href : null),
      onClick: function onClick() {
        return trackAddFavorites(user, entitlements);
      }
    },
    _react2.default.createElement(
      'div',
      { className: 'quiver-add-favorites__wrapper' },
      _react2.default.createElement(_AddIcon2.default, null),
      _react2.default.createElement(
        'div',
        { className: 'quiver-add-favorites__wrapper__content' },
        _react2.default.createElement(
          'h5',
          null,
          'Add favorites'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Quickly access the spots you care about most.'
        )
      )
    )
  );
};

AddFavorites.propTypes = {
  large: _propTypes2.default.bool,
  user: _userPropType2.default,
  entitlements: _entitlementsPropType2.default,
  window: _windowPropType2.default
};

AddFavorites.defaultProps = {
  large: false,
  user: null,
  entitlements: []
};

exports.default = AddFavorites;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/AddFavorites/AddFavorites.js
// module id = 516
// module chunks = 11